import { defineNuxtPlugin } from '#app/nuxt'
import { LazyArticleClassSuggestEdit, LazyArticleContact, LazyArticleCookies, LazyArticleCookiesAnalytical, LazyArticleCookiesNecessary, LazyArticleCookiesVideo, LazyArticleCookiesWhatAre, LazyArticleLearnSwing, LazyArticlePrivacy, LazyIconChevronRight, LazyIconClose, LazyIconEdit, LazyIconFullScreen, LazyIconLive, LazyIconLocation, LazyIconLock, LazyIconMuteOff, LazyIconMuteOn, LazyIconPlay, LazyIconSearch, LazyMissingVideo } from '#components'
const lazyGlobalComponents = [
  ["ArticleClassSuggestEdit", LazyArticleClassSuggestEdit],
["ArticleContact", LazyArticleContact],
["ArticleCookies", LazyArticleCookies],
["ArticleCookiesAnalytical", LazyArticleCookiesAnalytical],
["ArticleCookiesNecessary", LazyArticleCookiesNecessary],
["ArticleCookiesVideo", LazyArticleCookiesVideo],
["ArticleCookiesWhatAre", LazyArticleCookiesWhatAre],
["ArticleLearnSwing", LazyArticleLearnSwing],
["ArticlePrivacy", LazyArticlePrivacy],
["IconChevronRight", LazyIconChevronRight],
["IconClose", LazyIconClose],
["IconEdit", LazyIconEdit],
["IconFullScreen", LazyIconFullScreen],
["IconLive", LazyIconLive],
["IconLocation", LazyIconLocation],
["IconLock", LazyIconLock],
["IconMuteOff", LazyIconMuteOff],
["IconMuteOn", LazyIconMuteOn],
["IconPlay", LazyIconPlay],
["IconSearch", LazyIconSearch],
["MissingVideo", LazyMissingVideo],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
